import { render, staticRenderFns } from "./InputPage.vue?vue&type=template&id=3566ab6a"
import script from "./InputPage.vue?vue&type=script&lang=js"
export * from "./InputPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports